import requestConfig from 'Models/uiConfig/requestConfig';
import { getCookie, setCookie } from 'Utils/browserStorage';

const fiveYears = 5 * 365 * 24 * 60 * 60 * 1000;
const halfAnHour = 30 * 60 * 1000;

type Analytics = {
  userId: string;
  sessionId: string;
};

export default function getAnalytics(): Analytics {
  const enabled = requestConfig.isAnalyticsEnabled();
  let userId = enabled ? getOrCreateCookie('cmuid', fiveYears) : '';
  let sessionId = enabled ? getOrCreateCookie('cmsid', halfAnHour, { renew: true }) : '';

  return {
    get userId() {
      return requestConfig.isAnalyticsEnabled() ? (userId ||= getOrCreateCookie('cmuid', fiveYears)) : '';
    },
    get sessionId() {
      return requestConfig.isAnalyticsEnabled()
        ? (sessionId ||= getOrCreateCookie('cmsid', halfAnHour, { renew: true }))
        : '';
    },
  };
}

function getOrCreateCookie(
  name: string,
  duration: number,
  { renew = false }: { renew?: boolean } = {},
): string {
  const storedValue = getCookie(name);
  const value = storedValue || generateId();

  if (!storedValue || renew) {
    const date = new Date(Date.now() + duration);
    setCookie(name, value, date, {
      sameSite: 'lax',
      secure: window.location.protocol === 'https:',
    });
  }

  return value;
}

const idLength = 16;
const alphaNums = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
const sample = (arr: string): string => arr[Math.floor(Math.random() * arr.length)] || '';
function generateId(): string {
  for (let id = ''; ; id += sample(alphaNums)) {
    if (id.length === idLength) {
      return id;
    }
  }
}
